module.exports = "/images/link-onedrive.svg?e188ab044257d8350de03826c7aefe62";